import * as React from "react";
import PaperLayout from "components/PaperLayout/PaperLayout";
import { Errors } from "components/DataBaseComponent/DataBaseComponent";

interface LoadingProps {
    title: string;
    busy: Promise<any> | boolean;
    errors: Errors;
}

const Loading: React.StatelessComponent<LoadingProps> = props =>
    <PaperLayout
        title={props.title}
        busy={props.busy}
        errors={props.errors} />;

export default Loading;